import FJVideoTrimModel from '../../../../common/combineComponents/FJVideoTrimModel/FJVideoTrimModel';
import { useDispatch, useSelector } from 'react-redux';
import FJModal from '../../../FJModals/FJModal';
import FJActionAiVideoDub, { MODEL_MAX_VIDEO_DURATION } from '../../../../redux/action/FJActionAiVideoDub';
import FJActionModal from '../../../../redux/action/FJActionModal';

const FJVideoTrimContainer = () => {
    const videoTrimModelData = useSelector(state => state.modals.videoTrimModelData);
    const { display, data } = videoTrimModelData;
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(FJActionModal.hideVideoTrimModalAction());
    };

    const onCancel = () => {
        onClose();
    };

    const onApply = (trimBoxRelativeRect, callback) => {
        dispatch(FJActionAiVideoDub.applyTrimVideoAction(trimBoxRelativeRect, callback));
    };

    return (
        <FJModal visible={display} zIndex={1003}>
            <FJVideoTrimModel
                onClose={onClose}
                data={data}
                active={display}
                maxDuration={MODEL_MAX_VIDEO_DURATION}
                onCancel={onCancel}
                onApply={onApply}
            />
        </FJModal>
    );
};

export default FJVideoTrimContainer;
